import { hasFeature } from "@packages/core/session/features.ts";
import type { Role } from "@packages/core/session/roles.ts";

export const ORG_CHART_ACCESS: readonly Role[] = [hasFeature("OrgChart")];
